var products_on_page = $('.products-onpage');
var next_url = products_on_page.data('next-url');

var load_more_btn = $('.load-more_btn');
var load_more_spinner = $('.load-more_spinner');

var currentProductCount = $('.product-item').length;
$('.product-countbox').text(currentProductCount);

function loadMoreProducts() {
  // Get the current product count before making the AJAX request
  $.ajax({
    url: next_url,
    type: 'GET',
    dataType: 'html',
    beforeSend: function () {
      load_more_btn.hide();
      load_more_spinner.show();
    }
  }).done(function (next_page) {
    load_more_spinner.hide();
    var new_products = $(next_page).find('.products-onpage');
    var new_url = new_products.data('next-url');

    if (new_url) {
      load_more_btn.show();
    }

    next_url = new_url;

    products_on_page.append(new_products.html());

    // Update product count after appending new products
    var newProductCount = new_products.find('.product-item').length;
    var totalProductCount = currentProductCount + newProductCount;

    // Update the product count box
    $('.product-countbox').text(totalProductCount);
    
    // Update the current product count for the next load
    currentProductCount = totalProductCount;
  });
}


